'use client';

import { BriefingContent } from './briefing-content';
import type { BriefingSection } from './briefing-card';

// ---------------------------------------------------------------------------
// BriefingFlowView — renders all sections as a continuous document
// ---------------------------------------------------------------------------

interface BriefingFlowViewProps {
  sections: BriefingSection[];
}

export function BriefingFlowView({ sections }: BriefingFlowViewProps) {
  return (
    <div className="briefing-flow">
      {sections.map((section) => (
        <div
          key={section.index}
          id={`section-${section.index}`}
          className="briefing-flow-section mb-8 last:mb-0"
        >
          <h2 className="text-xl font-bold text-foreground mb-4 flex items-center gap-2">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent text-accent-foreground text-xs font-bold flex-shrink-0">
              {section.label ?? section.index}
            </span>
            {section.title}
          </h2>
          <BriefingContent markdown={section.markdown} />
        </div>
      ))}
    </div>
  );
}
